import client from '../httpClient';

const customerSearchApi = (params) => {
  const POST_CUSTOMER_SEARCH = '/customers/search/';
  return client.post(POST_CUSTOMER_SEARCH, params, { isShowLoading: false });
};

export default customerSearchApi;
